import React from 'react';
import apiclient from 'lib/apiclient';
import useAreas from 'hooks/useAreas';
import useSalesCoordinators from 'hooks/useSalesCoordinators';
import useSupportCoordinators from 'hooks/useSupportCoordinators';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { Formik, Form as FormikForm, Field} from 'formik';

const Table = (props) => {
  const areas = useAreas();
  const salesCoordinators = useSalesCoordinators();
  const supportCoordinators = useSupportCoordinators();
  const {
    onSubmit: handleSubmit
  } = props;

  return (
    <Formik initialValues={{
      id : '',
      name : '',
      areaId : 'tokyo',
      salesCoordinatorId : '',
      supportCoordinatorId : '',
      replyAddress : '',
      replyDisplayName : '',
      managementNumber : '',
      isFreeTrial : false,
      isDemo : false,
    }} onSubmit={handleSubmit}>
      <Form tag={FormikForm}>
        <FormGroup>
          <Label for="id">ID</Label>
          <Input tag={Field} id="id" name="id" placeholder="ID" />
        </FormGroup>
        <FormGroup>
          <Label for="managementNumber">課金データ管理番号</Label>
          <Input tag={Field} id="managementNumber" name="managementNumber" placeholder="課金データ管理番号" />
        </FormGroup>
        <FormGroup>
          <Label for="name">顧客名</Label>
          <Input tag={Field} id="name" name="name" placeholder="顧客名" />
        </FormGroup>
        <FormGroup>
          <Label for="area">エリア</Label>
          <Input tag={Field} as="select" id="area" name="areaId">
            <option value=""></option>
            {areas.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="salesCoordinator">営業担当者</Label>
          <Input tag={Field} as="select" id="salesCoordinator" name="salesCoordinatorId">
            <option value=""></option>
            {salesCoordinators.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="supportCoordinator">サポート担当者</Label>
          <Input tag={Field} as="select" id="supportCoordinator" name="supportCoordinatorId">
            <option value=""></option>
            {supportCoordinators.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="useToken" />{' '}トークン付きURLを使用(旧仕様)</Label>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="isFreeTrial" />{' '}体験版</Label>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="isDemo" />{' '}デモ版</Label>
        </FormGroup>
        <Button>保存</Button>
      </Form>
    </Formik>
  );
}

export default (props) => {
  const history = useHistory();

  const handleSubmit = React.useCallback((model) => {
    console.log(model);
    apiclient.post('api/customer', model)
      .then(() => {
        history.goBack();
      })
      .catch(e => {
        console.log(e);
        alert(e);
      });
  }, []);

  return (
    <div>
      <h1 id="tabelLabel" ><span onClick={() => history.goBack()}>顧客一覧</span> &#12297; 新規作成</h1>
      <Table onSubmit={handleSubmit} />
    </div>
  );
}